import { Functions } from '../utils/functions';

export const OffersService = {
    location_offers: (token, location_id, customer_id, medicare_cardNum=null) => {
        return new Promise((resolve, reject) => {
            fetch('https://api.medicareclub.ao/api/provider/locations/' + location_id +'/offers?customer_id=' + customer_id+'&medicareCard_number='+medicare_cardNum, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-club-key': token
                }
            })
            .then((response) => {
                if(response.ok) {
                    return response.json();
                } else {
                    Functions.error(response.status);
                    reject();
                    throw new Error('Something went wrong');
                }
            })
            .then(async (json) => {
                resolve(json);
            })
            .catch((err) => {
                reject(err);
            });
        });
    },
    location_offers_with_status: (token, location_id, status) => {
        return new Promise((resolve, reject) => {
            fetch('https://api.medicareclub.ao/api/provider/locations/' + location_id +'/offers?status=' + status, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-club-key': token
                }
            })
            .then((response) => {
                if(response.ok) {
                    return response.json();
                } else {
                    Functions.error(response.status);
                    reject();
                    throw new Error('Something went wrong');
                }
            })
            .then(async (json) => {
                resolve(json);
            })
            .catch((err) => {
                reject(err);
            });
        });
    },
    use_offer: (token, offer) => {
        return new Promise((resolve, reject) => {
            fetch('https://api.medicareclub.ao/api/provider/use_offer', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-club-key': token
                },
                body: JSON.stringify(offer)
            })
            .then((response) => {
                if(response.ok) {
                    return response.json();
                } else {
                    Functions.error(response.status);
                    reject();
                    throw new Error('Something went wrong');
                }
            })
            .then((json) => {
                // console.log(json)
                // resolve(json);
                if(json.error) {
                    reject(json.error)
                } else {
                    resolve(json);
                }
            })
            .catch((err) => {
                reject(err);
            });
        });
    }
};